import { SelectLayout } from "@amzn/stencil-react-components/form";
import {
  StatusEnum,
  DOC_UPLOAD_STATUS_CARD_STATES,
  EDM_DOC_TYPE,
  EDM_REVIEW_STATUS,
  EDM_UPLOAD_STATUS,
} from "../enums/common";
import { CAAS_STATUS } from "../../components/i9-task/i9-data";
import { RequiredPagesType } from "../../components/DocUpload/types";
import { MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import { ChecklistPantherKey } from "./translations";

export interface I9Response {
  isRemote?: boolean;
  errorCode?: string;
  secureURL?: string;
  allowRetry?: boolean;
  status?: string;
  PreviousrightToWorkExpired?: boolean;
  rightToWork?: any;
}

export interface I9TaskCardProps {
  status?: StatusEnum | CAAS_STATUS;
  shouldOverrideStatus?: Record<string, StatusEnum>;
}

export interface idInfo {
  nationalIdType: string;
  idNumber: string;
}

export interface additionalNationalIdsInfo {
  [keys: string]: idInfo;
}

export interface FormInputItem {
  id: string;
  name: string;
  type: string;
  dataKey: string;
  label: string;
  labelTranslationKey: ChecklistPantherKey;
  placeholder?: string;
  placeholderTranslationKey?: ChecklistPantherKey;
  hasError?: boolean;
  errorMessage?: string;
  errorMessageTranslationKey?: ChecklistPantherKey;
  defaultValue?: string;
  required?: boolean;
  inputType?: string;
  tooltip?: string;
  tooltipTranslationKey?: ChecklistPantherKey;
  handleChange?: Function;
  selectOptions?: any[];
  layout?: SelectLayout;
}

export interface BaseSelectOption {
  displayValue: string;
  value: string;
  translationKey: ChecklistPantherKey | "";
}

export interface DocUploadSelectOptions extends BaseSelectOption {
  documentParentCategory?: string;
  documentType: string;
  requiredPages: Array<RequiredPagesType>;
  noAction?: boolean;
}

export enum ActionPath {
  UPLOAD_DOCUMENT = "upload-documents",
  UPLOAD_DOCUMENTS_RTW = "upload-documents-rtw",
}

export interface EdmFile {
  fileName: string;
  contentType: string;
  contentSize: string;
}

export interface DocStatusCards extends EdmFile {
  reviewStatus?: EDM_REVIEW_STATUS;
  state: DOC_UPLOAD_STATUS_CARD_STATES;
  documentId: string;
  documentTypeId: EDM_DOC_TYPE;
  markForDeletion?: boolean;
  draftId: string;
  sha256: string;
  actionPath: ActionPath;
}

export interface EdmDocumentInfo {
  created_at: Date;
  upload_status: EDM_UPLOAD_STATUS; // Just 'status' in EDM
  review_status?: EDM_REVIEW_STATUS;
  document_type_id: EDM_DOC_TYPE;
  document_id: string;
  draft_id: string;
  sha256: string;

  // TODO: metadata is still tentative.
  files: EdmFile;
}

export interface DocumentsListResponse {
  documents: EdmDocumentInfo[];
}

export interface CommitUploadRequestItem {
  document_type_id: EDM_DOC_TYPE;
  document_id: string;
  draft_id: string;
}

export interface CommitUploadResponseItem {
  document_type_id: EDM_DOC_TYPE;
  document_id: string;
  draft_id: string;
  status: EDM_UPLOAD_STATUS;
}

export interface CommitUploadRequest {
  documentsMetadata: CommitUploadRequestItem[];
}

export interface CommitUploadResponse {
  commitStatuses: CommitUploadResponseItem[];
}

export interface DownloadNecessaryDocUploadItem {
  documentType: EDM_DOC_TYPE;
  documentName: string;
  documentId: string;
  downloadLink: string;
  downloadedDate?: Date;
  isDownloadedAtCurrentSession?: boolean;
  errorMessage?: string;
}

export interface Banner {
  type: MessageBannerType;
  text: string;
  isDismissible?: boolean;
  dismissTime?: number;
}

export interface AppConfig {
  configurationName: string;
  defaultValue: boolean;
  configurationType: any;
  siteFilters: any;
  taskId: any;
  definitions: any;
}

export interface AppConfigResponse {
  configurations: { configurationsArray: Array<AppConfig> };
}

export interface TaskStatus {
  taskType: string;
  taskStatus: string;
  candidateId: string;
  taskId: string;
  expirationDate?: string;
}
